"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("../IconButton"));
var styles_1 = require("./styles");
var prism_icons_1 = require("@octanner/prism-icons");
var NotificationBell_1 = __importDefault(require("./NotificationBell"));
var LogoLink_1 = __importDefault(require("./LogoLink"));
var MobileHeader = function (_a) {
    var handleNavigation = _a.handleNavigation, setNavOpen = _a.setNavOpen;
    return (react_1.default.createElement(styles_1.HeaderRow, { "data-testid": "mobile-header" },
        react_1.default.createElement(styles_1.HeaderInnerRow, null,
            react_1.default.createElement(styles_1.HeaderCell, null,
                react_1.default.createElement(IconButton_1.default, { onClick: function () { return setNavOpen(true); }, "aria-label": "open menu" },
                    react_1.default.createElement(prism_icons_1.MenuHamburger, null))),
            react_1.default.createElement(LogoLink_1.default, { handleNavigation: handleNavigation }),
            react_1.default.createElement(styles_1.HeaderCell, null,
                react_1.default.createElement(NotificationBell_1.default, { onClick: handleNavigation('/notifications') })))));
};
exports.default = MobileHeader;
//# sourceMappingURL=MobileHeader.js.map